import React, { useState } from 'react';
import styles from './FAQSection.module.scss';
import ContactConstant from '../../../utils/Constant/ContactConstant';

const faqs = [
    {
        question: 'Is this complete or still being built?',
        answer:
            'Prepal is in Early Access — the core practice engine, instant explanations, and adaptive testing are fully functional. We\'re actively building new features like the full diagnostic test, personalized study plans, and tutor marketplace based on user feedback. Early adopters get every future update included.',
    },
    {
        question: 'How is this different from Khan Academy (which is free)?',
        answer:
            'Khan Academy offers incredible general education content. Prepal is purpose-built for SAT test strategy. Our adaptive engine targets your specific weak areas, explains answers in the context of SAT scoring patterns, and our question bank is curated by tutors who\'ve helped 100+ students improve their scores. Think of it as having a dedicated SAT tutor available 24/7.',
    },
    {
        question: 'How does the instant explanation feature work?',
        answer:
            'When you get stuck on a question, you can ask for help and get a detailed, patient breakdown in plain language. The hints, support system, and explanations are curated. The real intelligence comes from our proprietary adaptive algorithm built on Item Response Theory (IRT). The practice routing, difficulty calibration, and score insights are powered by our own system built from 3+ years of tutoring data.',
    },
    {
        question: 'What if I need more help than the platform can provide?',
        answer: (
            <>
                That's exactly why we're building the Tutor Marketplace (coming in a future build). You'll be able to book 1-on-1 sessions with vetted SAT experts from our{' '}
                <a href="https://advprep.com" target="_blank" rel="noopener noreferrer" style={{ color: '#0257ef' }}>Advantage Prep</a>{' '}
                network who are pre-briefed on your specific struggles. Until then, the instant explanation feature handles most needs.
            </>
        ),
    },
    {
        question: 'What happens after I pay? Do I get charged again?',
        answer:
            'No. Early Access is a one-time payment of $40 USD (1,050,000 VND). No subscriptions, no hidden fees. You get full access now plus every future feature update. When we launch subscriptions later, early adopters keep a permanent 50% discount.',
    },
    {
        question: 'When does my access start?',
        answer:
            'Immediately after payment. You\'ll get full access to 1,200+ practice questions, the adaptive testing engine, instant explanations, and progress tracking right away.',
    },
];

const FAQSection = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

    return (
        <section className={styles.faqSection} aria-label="FAQ">
            <div className={styles.header}>
                <h2 className={styles.heading}>Common Questions</h2>
                <p className={styles.subtext}>
                    Still have questions? Email us at{' '}
                    <a href={`mailto:${ContactConstant.INFO_EMAIL}`} className={styles.emailLink}>
                        {ContactConstant.INFO_EMAIL}
                    </a>
                </p>
            </div>

            <div className={styles.list}>
                {faqs.map((faq, i) => {
                    const isOpen = openIndex === i;
                    return (
                        <div
                            key={i}
                            className={`${styles.item} ${isOpen ? styles.open : ''}`}
                        >
                            <button
                                className={styles.question}
                                aria-expanded={isOpen}
                                onClick={() => toggle(i)}
                            >
                                <span>{faq.question}</span>
                                <svg
                                    className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ''}`}
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    aria-hidden="true"
                                >
                                    <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>

                            {isOpen && (
                                <p className={styles.answer}>{faq.answer}</p>
                            )}
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default FAQSection;
